import { GetPeriodicsChecksMetricsInDto, GetPeriodicsChecksMetricsOutDto } from '../../../types/periodic-check.dto'

export const GET_PERIODICS_CHECKS_METRICS = 'GET_PERIODICS_CHECKS_METRICS'
export const GET_PERIODICS_CHECKS_METRICS_SUCCESS = 'GET_PERIODICS_CHECKS_METRICS_SUCCESS'
export const GET_PERIODICS_CHECKS_METRICS_ERROR = 'GET_PERIODICS_CHECKS_METRICS_ERROR'
export const RESET_GET_PERIODICS_CHECKS_METRICS = 'RESET_GET_PERIODICS_CHECKS_METRICS'

export interface GetPeriodicsChecksMetrics {
  type: typeof GET_PERIODICS_CHECKS_METRICS
  payload: GetPeriodicsChecksMetricsOutDto
}

export interface GetPeriodicsChecksMetricsSuccess {
  type: typeof GET_PERIODICS_CHECKS_METRICS_SUCCESS
  payload: GetPeriodicsChecksMetricsInDto
}

export interface GetPeriodicsChecksMetricsError {
  type: typeof GET_PERIODICS_CHECKS_METRICS_ERROR
  payload: string | boolean
}

export interface ResetGetPeriodicsChecksMetrics {
  type: typeof RESET_GET_PERIODICS_CHECKS_METRICS
  payload: null
}

export interface State {
  data: GetPeriodicsChecksMetricsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetPeriodicsChecksMetrics | GetPeriodicsChecksMetricsSuccess | GetPeriodicsChecksMetricsError | ResetGetPeriodicsChecksMetrics
